module.exports = __webpack_public_path__ + "img/cannister.951167da.svg";